<template>
    <footer class="text-inverse py-4" :style="{
        backgroundImage: `url(${bgFooter})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
    }">
        <div class="container">
            <p class="mb-0 text-center text-white">
                <strong>
                    Copyright &copy; {{ year }}
                    &bull; Powered by
                </strong>
                <a href="https://rdpl.co.id/">RDPL</a>
            </p>
        </div>
    </footer>
</template>

<script setup>
import bgFooter from '@/assets/img/bg-smilepicture.png'

const year = new Date().getFullYear()
</script>
